// import React, { useState, useEffect } from "react";
// import {
//   doc,
//   updateDoc,
//   getDocs,
//   deleteDoc,
//   query,
//   where,
//   collection,
// } from "firebase/firestore";
// import { db, auth } from "../../firebase";
// import { deleteUser } from "firebase/auth";

// const AgentList = () => {
//   const [filters, setFilters] = useState({
//     district: "",
//     mandal: "",
//     area: "",
//   });
//   const [view, setView] = useState("all");
//   const [agents, setAgents] = useState([]);

//   useEffect(() => {
//     fetchAgents();
//   }, []);

//   const fetchAgents = async () => {
//     try {
//       const currentUser = auth.currentUser;
//       if (!currentUser) {
//         console.log("No authenticated user. Skipping fetchAgents.");
//         return;
//       }

//       const querySnapshot = await getDocs(collection(db, "users"));
//       const data = querySnapshot.docs
//         .map((doc) => ({ id: doc.id, ...doc.data() }))
//         .filter((user) => user.role === "agent");
//       setAgents(data);
//     } catch (error) {
//       console.error("Error fetching agents:", error.message);
//     }
//   };

//   const totalAgents = agents.length;
//   const activeAgents = agents.filter((a) => a.isActive).length;
//   const inactiveAgents = totalAgents - activeAgents;

//   const toggleStatus = async (id, currentStatus) => {
//     try {
//       await updateDoc(doc(db, "users", id), {
//         isActive: !currentStatus,
//       });
//       fetchAgents();
//     } catch (error) {
//       console.error("Error updating status:", error.message);
//     }
//   };

//   // const handleDeleteAgent = async (agent) => {
//   //   const confirmDelete = window.confirm(
//   //     `Are you sure you want to delete agent "${agent.username}" and all their data?`
//   //   );
//   //   if (!confirmDelete) return;

//   //   try {
//   //     await deleteDoc(doc(db, "users", agent.id));

//   //     const creditQuery = query(
//   //       collection(db, "creditRequests"),
//   //       where("uid", "==", agent.uid)
//   //     );
//   //     const creditSnap = await getDocs(creditQuery);
//   //     for (const docSnap of creditSnap.docs) {
//   //       await deleteDoc(doc(db, "creditRequests", docSnap.id));
//   //     }

//   //     const downloadQuery = query(
//   //       collection(db, "downloads"),
//   //       where("uid", "==", agent.uid)
//   //     );
//   //     const downloadSnap = await getDocs(downloadQuery);
//   //     for (const docSnap of downloadSnap.docs) {
//   //       await deleteDoc(doc(db, "downloads", docSnap.id));
//   //     }

//   //     const currentUser = auth.currentUser;
//   //     if (currentUser && currentUser.uid === agent.uid) {
//   //       await deleteUser(currentUser);
//   //     } else {
//   //       console.warn("Cannot delete auth user without Admin SDK or re-auth.");
//   //     }

//   //     alert("Agent and all related data deleted.");
//   //     fetchAgents();
//   //   } catch (error) {
//   //     console.error("Error deleting agent:", error);
//   //     alert("Failed to delete agent.");
//   //   }
//   // };

//   const handleDeleteAgent = async (agent) => {
//     const confirmDelete = window.confirm(
//       `Are you sure you want to delete agent "${agent.username}" and all their data?`
//     );
//     if (!confirmDelete) return;

//     try {
//       // 1. Delete user document from Firestore
//       await deleteDoc(doc(db, "users", agent.id));

//       // 2. Delete related credit requests
//       const creditQuery = query(
//         collection(db, "creditRequests"),
//         where("uid", "==", agent.uid)
//       );
//       const creditSnap = await getDocs(creditQuery);
//       for (const docSnap of creditSnap.docs) {
//         await deleteDoc(doc(db, "creditRequests", docSnap.id));
//       }

//       // 3. Delete related downloads
//       const downloadQuery = query(
//         collection(db, "downloads"),
//         where("uid", "==", agent.uid)
//       );
//       const downloadSnap = await getDocs(downloadQuery);
//       for (const docSnap of downloadSnap.docs) {
//         await deleteDoc(doc(db, "downloads", docSnap.id));
//       }

//       // 4. Attempt to delete from Firebase Auth (only works if current user is the agent)
//       try {
//         const currentUser = auth.currentUser;
//         if (currentUser && currentUser.uid === agent.uid) {
//           await deleteUser(currentUser);
//           console.log("Deleted from Firebase Auth.");
//         } else {
//           console.warn("Auth deletion skipped. Admin SDK required.");
//         }
//       } catch (authError) {
//         console.warn("Auth deletion failed:", authError.message);
//       }

//       alert("Agent and all related data deleted from Firestore.");
//       fetchAgents();
//     } catch (error) {
//       console.error("Error deleting agent:", error);
//       alert("Failed to delete agent.");
//     }
//   };

//   const renderAgents = (filter) => {
//     return agents
//       .filter((agent) => {
//         if (filter === "active") return agent.isActive;
//         if (filter === "inactive") return !agent.isActive;
//         return true;
//       })
//       .filter((agent) => {
//         const { district, mandal, area } = filters;
//         return (
//           (!district || agent.district === district) &&
//           (!mandal || agent.mandal === mandal) &&
//           (!area || agent.area === area)
//         );
//       })
//       .map((agent) => (
//         <tr key={agent.id}>
//           <td>{agent.accountId}</td>
//           <td>{agent.username}</td>
//           <td>{agent.contact}</td>
//           <td>{agent.credits}</td>
//           <td>{agent.area}</td>
//           <td>{agent.mandal}</td>
//           <td>{agent.district}</td>
//           <td>{agent.isActive ? "Active" : "Inactive"}</td>
//           {view !== "all" && (
//             <td>
//               <button
//                 className="btn btn-sm btn-warning me-2"
//                 onClick={() => toggleStatus(agent.id, agent.isActive)}
//               >
//                 {agent.isActive ? "Deactivate" : "Activate"}
//               </button>
//               {!agent.isActive && view === "inactive" && (
//                 <button
//                   className="btn btn-sm btn-danger"
//                   onClick={() => handleDeleteAgent(agent)}
//                 >
//                   Delete
//                 </button>
//               )}
//             </td>
//           )}
//         </tr>
//       ));
//   };

//   return (
//     <div>
//       <div>
//         <h3>
//           {view === "all"
//             ? "All Agents"
//             : view === "active"
//             ? "Active Agents"
//             : "De-Active Agents"}
//         </h3>
//         <div className="d-flex flex-row gap-2">
//           <button
//             className="btn btn-outline-primary my-2"
//             onClick={() => setView("all")}
//           >
//             Agents List
//           </button>
//           <button
//             className="btn btn-outline-success my-2"
//             onClick={() => setView("active")}
//           >
//             Active List
//           </button>
//           <button
//             className="btn btn-outline-danger my-2"
//             onClick={() => setView("inactive")}
//           >
//             De-Active List
//           </button>
//         </div>
//       </div>

//       <div className="row g-2 mb-3">
//         {["district", "mandal", "area"].map((filter, i) => (
//           <div className="col-md-4" key={i}>
//             <input
//               className="form-control"
//               placeholder={`Filter by ${filter}`}
//               value={filters[filter]}
//               onChange={(e) =>
//                 setFilters({ ...filters, [filter]: e.target.value })
//               }
//             />
//           </div>
//         ))}
//       </div>

//       <div className="table-responsive">
//         <table className="table table-bordered table-striped mt-3">
//           <thead className="table-dark">
//             <tr>
//               <th>Account ID</th>
//               <th>Name</th>
//               <th>Contact</th>
//               <th>Credits</th>
//               <th>Area</th>
//               <th>Mandal</th>
//               <th>District</th>
//               <th>Status</th>
//               {view !== "all" && <th>Action</th>}
//             </tr>
//           </thead>
//           <tbody>{renderAgents(view)}</tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AgentList;

import React, { useState, useEffect } from "react";
import {
  doc,
  updateDoc,
  getDocs,
  deleteDoc,
  query,
  where,
  collection,
} from "firebase/firestore";
import { db, auth } from "../../firebase";
import { deleteUser } from "firebase/auth";
import UsersList from "./UsersList";

const AgentList = () => {
  const [filters, setFilters] = useState({
    district: "",
    mandal: "",
    area: "",
  });
  const [view, setView] = useState("welcome");
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.log("No authenticated user. Skipping fetchAgents.");
        return;
      }

      const querySnapshot = await getDocs(collection(db, "users"));
      const data = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => user.role === "agent");
      setAgents(data);
    } catch (error) {
      console.error("Error fetching agents:", error.message);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      await updateDoc(doc(db, "users", id), {
        isActive: !currentStatus,
      });
      fetchAgents();
    } catch (error) {
      console.error("Error updating status:", error.message);
    }
  };

  const handleDeleteAgent = async (agent) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete agent "${agent.username}" and all their data?`
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "users", agent.id));

      const creditQuery = query(
        collection(db, "creditRequests"),
        where("uid", "==", agent.uid)
      );
      const creditSnap = await getDocs(creditQuery);
      for (const docSnap of creditSnap.docs) {
        await deleteDoc(doc(db, "creditRequests", docSnap.id));
      }

      const downloadQuery = query(
        collection(db, "downloads"),
        where("uid", "==", agent.uid)
      );
      const downloadSnap = await getDocs(downloadQuery);
      for (const docSnap of downloadSnap.docs) {
        await deleteDoc(doc(db, "downloads", docSnap.id));
      }

      console.warn("Auth deletion skipped. Admin SDK required.");
      alert("Agent and all related data deleted from Firestore.");
      fetchAgents();
    } catch (error) {
      console.error("Error deleting agent:", error);
      alert("Failed to delete agent.");
    }
  };

  const renderAgents = (filter) => {
    return agents
      .filter((agent) => {
        if (filter === "active") return agent.isActive;
        if (filter === "inactive") return !agent.isActive;
        return true;
      })
      .filter((agent) => {
        const { district, mandal, area } = filters;
        return (
          (!district || agent.district === district) &&
          (!mandal || agent.mandal === mandal) &&
          (!area || agent.area === area)
        );
      })
      .map((agent) => (
        <tr key={agent.id}>
          <td>{agent.accountId}</td>
          <td>{agent.username}</td>
          <td>{agent.contact}</td>
          <td>{agent.credits}</td>
          <td>{agent.area}</td>
          <td>{agent.mandal}</td>
          <td>{agent.district}</td>
          <td>{agent.isActive ? "Active" : "Inactive"}</td>
          {view !== "all" && (
            <td>
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() => toggleStatus(agent.id, agent.isActive)}
              >
                {agent.isActive ? "Deactivate" : "Activate"}
              </button>
              {!agent.isActive && view === "inactive" && (
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDeleteAgent(agent)}
                >
                  Delete
                </button>
              )}
            </td>
          )}
        </tr>
      ));
  };

  const renderContent = () => {
    if (view === "welcome") {
      const totalAgents = agents.length;
      const activeAgents = agents.filter((a) => a.isActive).length;
      const inactiveAgents = totalAgents - activeAgents;

      return (
        <div className="p-4">
          <h4>Welcome to Agents List</h4>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="card text-white bg-primary mb-3">
                <div className="card-body">
                  <h5 className="card-title">Total Agents</h5>
                  <p className="card-text">{totalAgents}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card text-white bg-success mb-3">
                <div className="card-body">
                  <h5 className="card-title">Active Agents</h5>
                  <p className="card-text">{activeAgents}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card text-white bg-danger mb-3">
                <div className="card-body">
                  <h5 className="card-title">Inactive Agents</h5>
                  <p className="card-text">{inactiveAgents}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="row g-2 mb-3">
          {["district", "mandal", "area"].map((filter, i) => (
            <div className="col-md-4" key={i}>
              <input
                className="form-control"
                placeholder={`Filter by ${filter}`}
                value={filters[filter]}
                onChange={(e) =>
                  setFilters({ ...filters, [filter]: e.target.value })
                }
              />
            </div>
          ))}
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped mt-3">
            <thead className="table-dark">
              <tr>
                <th>Account ID</th>
                <th>Name</th>
                <th>Contact</th>
                <th>Credits</th>
                <th>Area</th>
                <th>Mandal</th>
                <th>District</th>
                <th>Status</th>
                {view !== "all" && <th>Action</th>}
              </tr>
            </thead>
            <tbody>{renderAgents(view)}</tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div className="container mt-4">
      <div className="d-flex flex-row gap-2 mb-3">
        <button
          className="btn btn-outline-dark"
          onClick={() => setView("welcome")}
        >
          Dashboard
        </button>
        <button
          className="btn btn-outline-primary"
          onClick={() => setView("all")}
        >
          Agents List
        </button>
        <button
          className="btn btn-outline-success"
          onClick={() => setView("active")}
        >
          Active List
        </button>
        <button
          className="btn btn-outline-danger"
          onClick={() => setView("inactive")}
        >
          De-Active List
        </button>
        {/* <button
          className="btn btn-outline-danger"
          onClick={() => setView("userslist")}
        >
          Users List
        </button> */}
      </div>

      {renderContent()}
    </div>
  );
};

export default AgentList;
